__turbopack_context__.v({
  "actions": "Disco-module__2Be9bG__actions",
  "adContent": "Disco-module__2Be9bG__adContent",
  "assetLink": "Disco-module__2Be9bG__assetLink",
  "banner": "Disco-module__2Be9bG__banner",
  "bannerArrow": "Disco-module__2Be9bG__bannerArrow",
  "bannerArrowNext": "Disco-module__2Be9bG__bannerArrowNext",
  "bannerArrowPrev": "Disco-module__2Be9bG__bannerArrowPrev",
  "bannerBodyClamped": "Disco-module__2Be9bG__bannerBodyClamped",
  "bannerCopy": "Disco-module__2Be9bG__bannerCopy",
  "bannerImage": "Disco-module__2Be9bG__bannerImage",
  "bannerMedia": "Disco-module__2Be9bG__bannerMedia",
  "bannerNudge": "Disco-module__2Be9bG__bannerNudge",
  "bannerPosition": "Disco-module__2Be9bG__bannerPosition",
  "bannerSwipeArea": "Disco-module__2Be9bG__bannerSwipeArea",
  "bannerTitle": "Disco-module__2Be9bG__bannerTitle",
  "brandBlock": "Disco-module__2Be9bG__brandBlock",
  "brandLogo": "Disco-module__2Be9bG__brandLogo",
  "brandName": "Disco-module__2Be9bG__brandName",
  "btn": "Disco-module__2Be9bG__btn",
  "container": "Disco-module__2Be9bG__container",
  "contentRow": "Disco-module__2Be9bG__contentRow",
  "counter": "Disco-module__2Be9bG__counter",
  "coverCarousel": "Disco-module__2Be9bG__coverCarousel",
  "coverCarouselLeft": "Disco-module__2Be9bG__coverCarouselLeft",
  "coverCarouselLeftBottom": "Disco-module__2Be9bG__coverCarouselLeftBottom",
  "coverCarouselLeftTop": "Disco-module__2Be9bG__coverCarouselLeftTop",
  "coverCarouselRight": "Disco-module__2Be9bG__coverCarouselRight",
  "coverCloseBtn": "Disco-module__2Be9bG__coverCloseBtn",
  "coverDivider": "Disco-module__2Be9bG__coverDivider",
  "coverFadeIn": "Disco-module__2Be9bG__coverFadeIn",
  "coverInline": "Disco-module__2Be9bG__coverInline",
  "coverInlineContent": "Disco-module__2Be9bG__coverInlineContent",
  "coverInlineIcon": "Disco-module__2Be9bG__coverInlineIcon",
  "coverInlineLeft": "Disco-module__2Be9bG__coverInlineLeft",
  "coverInlineRight": "Disco-module__2Be9bG__coverInlineRight",
  "coverInlineSubtext": "Disco-module__2Be9bG__coverInlineSubtext",
  "coverInlineText": "Disco-module__2Be9bG__coverInlineText",
  "coverLogoImage": "Disco-module__2Be9bG__coverLogoImage",
  "coverModal": "Disco-module__2Be9bG__coverModal",
  "coverModalNoPadding": "Disco-module__2Be9bG__coverModalNoPadding",
  "coverOverlay": "Disco-module__2Be9bG__coverOverlay",
  "coverTeaserHeading": "Disco-module__2Be9bG__coverTeaserHeading",
  "coverTeaserSubheading": "Disco-module__2Be9bG__coverTeaserSubheading",
  "disclosureLink": "Disco-module__2Be9bG__disclosureLink",
  "dot": "Disco-module__2Be9bG__dot",
  "dotActive": "Disco-module__2Be9bG__dotActive",
  "dotIndicator": "Disco-module__2Be9bG__dotIndicator",
  "eddDrawerBody": "Disco-module__2Be9bG__eddDrawerBody",
  "eddDrawerCard": "Disco-module__2Be9bG__eddDrawerCard",
  "eddDrawerClose": "Disco-module__2Be9bG__eddDrawerClose",
  "eddDrawerDate": "Disco-module__2Be9bG__eddDrawerDate",
  "eddDrawerGrabber": "Disco-module__2Be9bG__eddDrawerGrabber",
  "eddDrawerHeader": "Disco-module__2Be9bG__eddDrawerHeader",
  "eddDrawerNoEddTitle": "Disco-module__2Be9bG__eddDrawerNoEddTitle",
  "eddDrawerOrder": "Disco-module__2Be9bG__eddDrawerOrder",
  "eddDrawerStatus": "Disco-module__2Be9bG__eddDrawerStatus",
  "eddOffer": "Disco-module__2Be9bG__eddOffer",
  "eddOfferActions": "Disco-module__2Be9bG__eddOfferActions",
  "eddOfferBody": "Disco-module__2Be9bG__eddOfferBody",
  "eddOfferContent": "Disco-module__2Be9bG__eddOfferContent",
  "eddOfferCounter": "Disco-module__2Be9bG__eddOfferCounter",
  "eddOfferDecline": "Disco-module__2Be9bG__eddOfferDecline",
  "eddOfferHeading": "Disco-module__2Be9bG__eddOfferHeading",
  "eddOfferLogo": "Disco-module__2Be9bG__eddOfferLogo",
  "eddOfferTitleBlock": "Disco-module__2Be9bG__eddOfferTitleBlock",
  "eddOfferTop": "Disco-module__2Be9bG__eddOfferTop",
  "featuredImage": "Disco-module__2Be9bG__featuredImage",
  "ghost": "Disco-module__2Be9bG__ghost",
  "heading": "Disco-module__2Be9bG__heading",
  "headingWithImage": "Disco-module__2Be9bG__headingWithImage",
  "imageContent": "Disco-module__2Be9bG__imageContent",
  "inlineBanner": "Disco-module__2Be9bG__inlineBanner",
  "inlineBannerActions": "Disco-module__2Be9bG__inlineBannerActions",
  "inlineBannerBrand": "Disco-module__2Be9bG__inlineBannerBrand",
  "inlineBannerBrandRow": "Disco-module__2Be9bG__inlineBannerBrandRow",
  "inlineBannerCopy": "Disco-module__2Be9bG__inlineBannerCopy",
  "inlineBannerDecline": "Disco-module__2Be9bG__inlineBannerDecline",
  "inlineBannerHead": "Disco-module__2Be9bG__inlineBannerHead",
  "inlineBannerLogo": "Disco-module__2Be9bG__inlineBannerLogo",
  "inlineBannerMedia": "Disco-module__2Be9bG__inlineBannerMedia",
  "inlineBannerName": "Disco-module__2Be9bG__inlineBannerName",
  "inlineBannerTitle": "Disco-module__2Be9bG__inlineBannerTitle",
  "inlineLayout": "Disco-module__2Be9bG__inlineLayout",
  "mobileCoverCloseBtn": "Disco-module__2Be9bG__mobileCoverCloseBtn",
  "mobileCoverWrapper": "Disco-module__2Be9bG__mobileCoverWrapper",
  "panelTitle": "Disco-module__2Be9bG__panelTitle",
  "pillActions": "Disco-module__2Be9bG__pillActions",
  "primary": "Disco-module__2Be9bG__primary",
  "primaryBtn": "Disco-module__2Be9bG__primaryBtn",
  "secondaryBtn": "Disco-module__2Be9bG__secondaryBtn",
  "sponsoredBadge": "Disco-module__2Be9bG__sponsoredBadge",
  "sponsoredPill": "Disco-module__2Be9bG__sponsoredPill",
  "storyBar": "Disco-module__2Be9bG__storyBar",
  "storyBarFill": "Disco-module__2Be9bG__storyBarFill",
  "storyBarFull": "Disco-module__2Be9bG__storyBarFull",
  "storyBars": "Disco-module__2Be9bG__storyBars",
  "storyCount": "Disco-module__2Be9bG__storyCount",
  "storyFill": "Disco-module__2Be9bG__storyFill",
  "storyNav": "Disco-module__2Be9bG__storyNav",
  "subheading": "Disco-module__2Be9bG__subheading",
  "textContent": "Disco-module__2Be9bG__textContent",
  "wrapper": "Disco-module__2Be9bG__wrapper",
});
